import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import AccessDeniedPage from '../pages/AccessDeniedPage';
import PropTypes from 'prop-types';

const RoleRoute = ({ allowedRoles, children }) => {
   const { user } = useContext(AuthContext);
  
  if (!user) return <Navigate to="/login" />;
  
  if (!allowedRoles.includes(user.role)) {
    return <AccessDeniedPage requiredRoles={allowedRoles} />;
  }
  
  return children;
};

RoleRoute.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired,
};

export default RoleRoute;
